export default {
  show (context, show) {
    context.commit('setShow', show);
  },
};
